import PreUndoData from "./PreUndoData";

export default class SetCurrentTrackData extends PreUndoData {
    // placeholder, the actual data is set on the command when the event is received
}